import React from 'react';

function classWithModifier(modifier, className){
  return [className, `${ className }--${ modifier }`, ].join(' ');
}

function facebookButtonMessage(blockName, { modifier, prefix, suffix, }){
  const getClassWithModifier = classWithModifier.part(modifier);
  return (
    <h5 className={ getClassWithModifier(`${ blockName }__message`) }>
      { prefix + ' ' }
      <strong className={ getClassWithModifier(`${ blockName }__latest-news`) }>
        latest news
      </strong>
      { ' ' + suffix }
    </h5>
  );
}

const FACEBOOK_BOT_BUTTON_MESSAGES = [
  {
    modifier: 'long',
    prefix: 'Click here to get the',
    suffix: 'about your favourite team on Facebook Messenger',
  },
];

function createFacebookBotMessages(blockName){
  const facebookButtonMessageWithBlockName = facebookButtonMessage.part(blockName);
  return FACEBOOK_BOT_BUTTON_MESSAGES.map(facebookButtonMessageWithBlockName);
}


function getIndexInRange(requestedIndex, size){
  return requestedIndex >= size ? requestedIndex % size : requestedIndex;
}

const NO_INDEX = null;
function getRequestedIndexOrRandomMessage(size, requestedIndex = NO_INDEX){
  return requestedIndex === NO_INDEX ?
    Math.floor(Math.random() * size) :
    getIndexInRange(requestedIndex, size);
}

export default function getRandomFacebookBotButtonMessage(blockName, index){
  const messages = createFacebookBotMessages(...arguments);
  return messages[getRequestedIndexOrRandomMessage(messages.length, index)];
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/facebook_bot/components/facebook-bot-button-messages.js